import { resolvePlaceholders } from '../queryParams/placeholder';

export interface CustomDataEntry {
  key?: string;
  value?: string;
}

interface Args {
  entries?: CustomDataEntry[];
  values: Record<string, string>;
}

/**
 * The `custom_data` Meta receives: the configured pairs with their
 * `{{fieldName}}` placeholders swapped for what the visitor submitted. A pair
 * left without a value is dropped - an empty parameter tells Meta nothing.
 */
export const resolveCustomData = ({
  entries,
  values,
}: Args): Record<string, string> | undefined => {
  if (!entries?.length) return undefined;

  const resolved = entries.reduce<Record<string, string>>(
    (acc, { key, value }) => {
      if (!key || !value) return acc;

      const filled = resolvePlaceholders({ template: value, values });
      if (filled) acc[key] = filled;

      return acc;
    },
    {},
  );

  return Object.keys(resolved).length ? resolved : undefined;
};
